import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable} from 'rxjs';
import { ApiResponse } from '../interfaces/api-response';
import { SuperAdminService } from '../services/api/super-admin.service';

@Injectable({
  providedIn: 'root'
})
export class ClientsResolver implements Resolve<ApiResponse> {

    constructor(private superAdminService: SuperAdminService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ApiResponse> {
        let clients = this.superAdminService.getClient();
        return clients;
    }
}
